import React, { useState } from "react";
import faqScrollHead from "../../../assets/faq-scroll.png";
import { RiArrowDownSFill } from "react-icons/ri";
const FaqCollapsible = (props) => {
  // State to dynamically expand and collapse the collapsible
  const [collapsibleStyle, setcollapsibleStyle] = useState({
    marginTop: "-7%",
    marginBottom: "-7%",
    height: "10rem",
  });

  // State to track whether collapsible is collapsed or expanded. true means expanded
  const [collapsibleState, setcollapsibleState] = useState(false);

  const toggleCollapse = () => {
    if (!collapsibleState) {
      // If collapsible is collapsed, expand it
      setcollapsibleStyle({
        marginTop: "-6.4%",
        marginBottom: "-6.4%",
        height: "18rem",
      });
    } else if (collapsibleState) {
      // If collapsible is expanded, collapse it
      setcollapsibleStyle({
        marginTop: "-7%",
        marginBottom: "-7%",
        height: "10rem",
      });
    }
    setcollapsibleState(!collapsibleState);
  };
  return (
    <div
      onClick={toggleCollapse}
      className="faq-collapsible-outer w-full md:w-8/12"
    >
      <img
        src={faqScrollHead}
        className="faqScroll scrollTop"
        alt="Faq Scroll head top"
      ></img>
      <div className="faq-collapsible-inner" style={collapsibleStyle}>
        <p className="font-title text-black text-base lg:text-xl text-center mb-2">
          {props.ques}
        </p>
        {collapsibleState && (
          <p className="font-content text-gray-700 text-xs lg:text-base text-justify px-4">
            {props.ans}
          </p>
        )}
        <RiArrowDownSFill
          size="40px"
          className="text-black arrowStyle"
          style={
            collapsibleState
              ? { transform: "rotate(180deg)" }
              : { transform: "rotate(0deg)" }
          }
        />
      </div>
      <img
        src={faqScrollHead}
        className="faqScroll scrollBottom"
        alt="Faq Scroll head top"
      ></img>
    </div>
  );
};
export default FaqCollapsible;
